import script from "./b-water.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-water.vue?vue&type=script&lang=ts&setup=true"

import "./b-water.vue?vue&type=style&index=0&id=220a79f2&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-220a79f2"]])

export default __exports__